<template>
  <div
    class="netpa-list-page-view-toggle"
    dir="rtl"
    role="group"
    :aria-label="ariaLabel"
  >
    <button
      type="button"
      class="netpa-list-page-view-toggle__btn"
      :class="{ 'netpa-list-page-view-toggle__btn--active': value }"
      :aria-pressed="value ? 'true' : 'false'"
      @click="$emit('input', true)"
    >
      <i class="fas fa-columns" aria-hidden="true"></i>
      <span>ستونی</span>
    </button>
    <button
      v-if="showList"
      type="button"
      class="netpa-list-page-view-toggle__btn"
      :class="{ 'netpa-list-page-view-toggle__btn--active': !value }"
      :aria-pressed="!value ? 'true' : 'false'"
      @click="$emit('input', false)"
    >
      <i class="fas fa-list-alt" aria-hidden="true"></i>
      <span>ردیفی</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "NetPaViewToggle",
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    showList: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String,
      default: "نوع نمایش",
    },
  },
};
</script>
